import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Helmet} from 'react-helmet';

import HeaderBrief from 'components/profile/HeaderBrief';
import AmateurFilmList from 'components/list/AmateurFilmList';
import Loading from 'components/Loading';
import NotFound from 'containers/NotFound';

import {getProfileAmateurFilms} from 'reducers/profileAmateurFilms';

import {t, dt} from 'l10n'

import 'sass/profile/ProfileIndex.scss';
import 'sass/profile/ProfileAmateurFilms.scss';
import queryString from "query-string";

class ProfileAmateurFilms extends Component {
    constructor(props) {
        super(props);

        this.state = {
            order: 'date'
        };
    }

    componentDidMount() {
        let {dispatch, match, user} = this.props;
        let {order} = this.state;
        if (!user || match.params.nick !== user.nick) {
            this.constructor.fetchData({dispatch, match, params: {order}});
        }
    }

    static fetchData({dispatch, match, params = {order: 'date'}}) {
        let {nick} = match.params,
            {order} = params;
        return dispatch(getProfileAmateurFilms(nick, order));
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.order !== nextState.order) {
            let {dispatch, match} = nextProps,
                {order} = nextState;

            this.constructor.fetchData({
                dispatch,
                match,
                params: {order}
            });
        }
    }

    updateOrder(order) {
        let {history, location} = this.props;

        let params = { order };

        this.setState({order});
        
        history.push(
            location.pathname + '#' + queryString.stringify(params)
        );
    }

    render() {
        let {order} = this.state;

        let {match, user, online, amateurFilms} = this.props,
            {list, totalCount} = amateurFilms;

        if (!user) {
            return <Loading centered/>;
        }

        if (user._notFound) {
            return <NotFound {...this.props}/>
        }

        return (
            <div id="wrapper">
                <HeaderBrief user={user} online={online} match={match}/>
                {user &&
                    <Helmet>
                        <title>{dt('meta', 'Amateur films of %1', user.nick)}</title>
                    </Helmet>
                }
                <aside className="profile-myfilms">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('Videos')} <em>{totalCount}</em></h2>
                            <div className="sort">
                                <p>{t('Sort by:')}</p>
                                <div className="ui-selector ui-mini film-sort-selector">
                                    <div className={order === 'date' ? 'active' : ''} onClick={() => this.updateOrder("date")}>{t('date')}</div>
                                    <div className={order === 'views' ? 'active' : ''} onClick={() => this.updateOrder("views")}>{t('popularity')}</div>
                                </div>
                            </div>
                        </div>

                        <AmateurFilmList amateurFilms={list} showStats showDate />

                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        user: state.profileAmateurFilms.user,
        online: state.profileAmateurFilms.online,
        amateurFilms: state.profileAmateurFilms.amateurFilms,
        currentUser: state.currentUser
    }),
    null
)(ProfileAmateurFilms)


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileAmateurFilms.js